import { PropTypes } from "prop-types"

const Segment = ({ isMounted, name, segment }) => {
  const digits = segment.split("")

  return digits.map((digit, i) => (
    <div
      className="flex w-9 justify-center align-baseline font-bold"
      key={`${name}_${digit}_${i}`}
    >
      {isMounted && <span>{digit}</span>}
    </div>
  ))
}

Segment.propTypes = {
  isMounted: PropTypes.bool,
  name: PropTypes.string.isRequired,
  segment: PropTypes.string.isRequired,
}

export default Segment
